<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title" style="font-weight:600;">{{'Inspection Planner' | translate | async}}</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
    </div>
    <div class="ttmodal__body center" *ngIf="_isLoading">
        <mat-spinner [color]="warn" [mode]="indeterminate"></mat-spinner>
    </div>
    <div class="ttmodal__body" *ngIf="!_isLoading">
        <div class="input-group-title margin-bottom-20" style="font-weight:600;">Forecast Method - Manual</div>
        <div class="margin-bottom-20">
            <mat-radio-group name="forecast" id="Forecast" aria-label="Select an option"
                [(ngModel)]="equipment.ForecastMethod">
                <mat-radio-button [value]="1">Hour</mat-radio-button>
                <mat-radio-button [value]="2">Distance</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="input-group-description">On average how many hours is this equipment in use.</div>
        <mat-form-field class="margin-right-10">
            <input matInput value="0" type="number" [(ngModel)]="equipment.HoursOfUsePerDay" ngDefaultControl required>
            <span matSuffix>{{'Hours per Day' | translate | async}}</span>
        </mat-form-field>
        <mat-form-field>
            <input matInput value="0" type="number" [(ngModel)]="equipment.AvgDistance" ngDefaultControl required>
            <span matSuffix>Usage Distance ({{userUOD}}) per day</span>
        </mat-form-field>
        <div class="margin-bottom-20">
            <div class="input-group-title margin-bottom-20 ">On what days is equipment in use</div>
            <mat-checkbox [labelPosition]="labelPosition" class="margin-right-10" [(ngModel)]="equipment.UsedMonday"
                ngDefaultControl>{{'Mon' | translate | async}}</mat-checkbox>
            <mat-checkbox [labelPosition]="labelPosition" class="margin-right-10" [(ngModel)]="equipment.UsedTuesday"
                ngDefaultControl>{{'Tue' | translate | async}}</mat-checkbox>
            <mat-checkbox [labelPosition]="labelPosition" class="margin-right-10" [(ngModel)]="equipment.UsedWednesday"
                ngDefaultControl>{{'Wed' | translate | async}}</mat-checkbox>
            <mat-checkbox [labelPosition]="labelPosition" class="margin-right-10" [(ngModel)]="equipment.UsedThursday"
                ngDefaultControl>{{'Thu' | translate | async}}</mat-checkbox>
            <mat-checkbox [labelPosition]="labelPosition" class="margin-right-10" [(ngModel)]="equipment.UsedFriday"
                ngDefaultControl>{{'Fri' | translate | async}}</mat-checkbox>
            <mat-checkbox [labelPosition]="labelPosition" class="margin-right-10" [(ngModel)]="equipment.UsedSaturday"
                ngDefaultControl>{{'Sat' | translate | async}}</mat-checkbox>
            <mat-checkbox [labelPosition]="labelPosition" [(ngModel)]="equipment.UsedSunday" ngDefaultControl>{{'Sun' |
                translate | async}}</mat-checkbox>
        </div>


        <div>
            <div class="input-group-title margin-bottom-20">Forecast- Future Inspections </div>
            <div class="input-group-description">{{'How often will you be inspecting this equipment? We will use this to help forecast future inspections. ' | translate | async}}</div>
            <mat-form-field class="margin-right-10">
                <input matInput placeholder="{{'I will inspect every' | translate | async}}" type="number"
                    [(ngModel)]="equipment.InspectEvery" ngDefaultControl required>
            </mat-form-field>
            <mat-form-field>
                <mat-select [(ngModel)]="equipment.InspectEveryUnitTypeId" ngDefaultControl required>
                    <mat-option [value]="unit.Id" *ngFor="let unit of unitList">
                        {{unit.Name | translate | async}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="input-group-title margin-bottom-20">{{'Manually Schedule Next Inspection' | translate | async}}</div>
            <mat-form-field class="input margin-right-10">
                <input matInput [matDatepicker]="myDatepicker" placeholder="{{'Manually Schedule Next Inspection' | translate | async}}"
                    [(ngModel)]="equipment.ManualDate" readonly>
                <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>

                <!-- Cross Button -->
                <button mat-icon-button matSuffix (click)="equipment.ManualDate = null">
                    <mat-icon style="font-size: 26px;">close</mat-icon>
                </button>

                <mat-datepicker #myDatepicker></mat-datepicker>
            </mat-form-field> Or
            <mat-form-field class="margin-left-10">
                <input matInput placeholder="Hours" type="number" [(ngModel)]="equipment.ManualHours" ngDefaultControl>

                <!-- Cross Button -->
                <button mat-icon-button matSuffix (click)="equipment.ManualHours = 0">
                    <mat-icon style="font-size: 26px;">close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div style="display: flex;justify-content: space-between;" class="margin-bottom-20" *ngIf="inspectionId!=0">
            <div class="input-group-title margin-bottom-20">{{'Advance Forecast Settings' | translate | async}}</div>
            <div style="text-align: right;">
                <i *ngIf="!Istrue" class="material-icons inventory-modal__close-button" (click)="ShowDiv()"
                    style="cursor: pointer;font-size: 34px;">add</i>
                <i *ngIf="Istrue" class="material-icons inventory-modal__close-button" (click)="ShowDiv()"
                    style="cursor: pointer;font-size: 34px;">minimize</i>
            </div>
        </div>

        <div *ngIf="Istrue">
            <div class="input-group-title margin-bottom-20">   {{'Display Settings- Current Forecast Status & Safety Margin' | translate | async}}    </div>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="equipment.Calculatemethod"
                class="margin-right-10">
                <mat-radio-button [value]="2">Manual average</mat-radio-button>
                <mat-radio-button [value]="1">System Calculate</mat-radio-button>
                <mat-radio-button [value]="3">Greater Average</mat-radio-button>
            </mat-radio-group>
            <mat-checkbox [labelPosition]="labelPosition" class="margin-right-10" [(ngModel)]="equipment.SafetyCheck"
                ngDefaultControl>   {{'Add Safety' | translate | async}}</mat-checkbox>
            <mat-form-field>
                <input matInput value="0" type="number" [(ngModel)]="equipment.SafetyCheckValue" ngDefaultControl
                    required>
                <span matSuffix>%</span>
            </mat-form-field>
        </div>
        <mat-form-field>
             <input  matInput  placeholder="{{'Distance Ratio' | translate | async}}"  type="text"  [(ngModel)]="equipment.DistanceRatio" (input)="limitOneDecimal($event)" ngDefaultControl>
        </mat-form-field>
    </div>
    <div class="ttmodal__footer" style="text-align: right;">
        <button mat-raised-button (click)="onNoClick()">{{'Cancel' | translate | async}}</button>
        <button class="margin-left-5" *ngIf="isInspector" mat-raised-button color="warn" [class.loading]="saving"
            (click)="updateInspectionPlanner(); ">
            <span class="material-icons button__icon">check</span>
            <span class="button__text"> {{'Save & Update' | translate | async}}</span>
        </button>
    </div>
</div>